"use strict";require('@ebay/skin/section-notice');
require('@ebay/skin/icon');